<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-row  align="center" justify="center">
      <v-col cols="12" sm="4">
        <v-date-picker color="brand" v-model="dates" range></v-date-picker>
      </v-col>
      <v-col cols="12" sm="3">
        <v-icon color="error">*</v-icon>
        <v-autocomplete
          color="#0F2027"
          dense
          v-model="cay"
          return-object
          item-text="ay"
          :items="ay_list"
          label="Select AY"
          persistent-hint
          filled
          hint="Please Select AY"
        />
      </v-col>
      <v-col cols="12" sm="3">
        <v-text-field
          v-model="dateRangeText"
          label="Date range"
          prepend-icon="mdi-calendar"
          readonly
          hint="From date ~ To date [Format:yyyy-MM-dd]"
          persistent-hint
          filled
        ></v-text-field>

        <v-radio-group v-model="user_type" row>
          <v-radio color="brand" label="Parent" value="Parent"></v-radio>
          <v-radio color="brand" label="Student" value="Student"></v-radio>
          <v-radio color="brand" label="Employee" value="Employee"></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>

    <hr><br>

    <v-row align="center" justify="center">
      <v-btn @click="logins" :loading="log_loader">Logins</v-btn>
    </v-row>

    <h3 v-if="login_count !== ''" style="padding-left: 20px; margin-left: 10px;">
      Logins count: {{ login_count }}
    </h3>

    <!-- Single table for all user types -->
    <div v-if="tableItems.length > 0" style="max-height: 400px; overflow-y: auto; padding-left: 20px; margin-left: 10px; border: 1px solid #ccc; border-radius: 4px;">
      <v-data-table
        :headers="tableHeaders"
        :items="tableItems"
        :search="search"
        :items-per-page="10"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            style="margin: 10px;"
          ></v-text-field>
        </template>
        <!-- Custom footer to display login_count as the total -->
        <template v-slot:footer.page-text="footer">
          Total: {{ login_count }} items
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data: () => ({
    snackbar_msg: "",
    color: "",
    snackbar: false,
    overlay: false,

    ay_list: [],
    cay: null, 

    dates: [],
    user_type: 'Parent',
    parent_login_details: [],
    login_count: '',
    login_usernames_from_logs: [],
    emp_login_details: [],
    search: '',
    log_loader: false,
    export_loader: false,
    logins_clicked: false, 
  }),
  computed: {
    dateRangeText() {
      return this.dates.join(' ~ ')
    },
    tableHeaders() {
      return [
        { text: 'Sr. No.', value: 'sr_no', sortable: false },
        { text: 'Name', value: 'name' },
        { text: 'PRN', value: 'prn' },
        { text: 'Username', value: 'email' },
      ];
    },
    tableItems() {
      if (this.user_type === 'Parent' || this.user_type === 'Student') {
        return this.parent_login_details.map((item, index) => ({
          sr_no: index + 1, // Add serial number starting from 1
          name: item.stud_name || '',
          prn: item.stud_regno || '',
          email: item.stud_parent_login || '', 
        }));
      } else if (this.user_type === 'Employee') {
        return this.emp_login_details.map((item, index) => ({
          sr_no: index + 1, // Add serial number starting from 1
          name: item.emp_name || '',
          prn: item.emp_code || '',
          email: item.emp_login || '', 
        }));
      }
      return [];
    },
    combinedUsernames() {
      if (this.user_type === 'Parent' || this.user_type === 'Student') {
        const parentUsernames = this.parent_login_details.map(item => item.stud_parent_login).filter(Boolean);
        return [...new Set([...parentUsernames, ...this.login_usernames_from_logs])];
      } else if (this.user_type === 'Employee') {
        const empUsernames = this.emp_login_details.map(item => item.emp_login).filter(Boolean);
        return [...new Set([...empUsernames, ...this.login_usernames_from_logs])];
      }
      return [];
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    showSnackbar(clr, msg) {
      this.snackbar = true
      this.color = clr
      this.snackbar_msg = msg
    },
    onerror(error) {
      let msg = ""
      if (error.response) {
        msg = error.response.data.snackbar || "Something went wrong."
      } else if (error.request) {
        msg = "Please try again."
      } else {
        msg = "Unexpected error."
      }
      this.showSnackbar("error", msg)
    },
    async init() {
      this.overlay = true
      try {
        const res = await axios.post("/commonAPI/getAYSem")
        if (res.data.flag == "YES") {
          this.ay_list = res.data.ay_list
          this.cay = res.data.cay
          this.showSnackbar("green", res.data.snackbar)
        } else {
          this.showSnackbar("red", res.data.snackbar)
          sessionStorage.setItem("error-trace", res.data.error_trace)
        }
      } catch (err) {
        console.log("init error:", err)
        this.onerror(err)
      } finally {
        this.overlay = false
      }
    },
    async logins() {
      if (!this.cay) {
        alert("Please select Academic Year")
        return
      }
      if (this.dates.length != 2) {
        alert("Please select 2 dates")
        return
      }
      if (this.dates[0] == this.dates[1]) {
        alert("Please select 2 different dates")
        return
      }

      const data = {
        cay: this.cay.id,
        dates: this.dates,
        user_type: this.user_type,
      }

      try {
        this.log_loader = true
        this.logins_clicked = true // Set flag to show count
        const res = await axios.post("/admin/getlogins", data)
        console.log("API response:", res.data)
        if (res.data.flag == "NO") {
          this.showSnackbar("red", res.data.snackbar)
          this.parent_login_details = []
          this.emp_login_details = []
          this.login_usernames_from_logs = []
        } else {
          this.parent_login_details = res.data.parent_login_details || []
          this.emp_login_details = res.data.emp_login_details || []
          this.login_usernames_from_logs = res.data.login_usernames_from_logs || []
          this.login_count = res.data.login_count || 0 
          console.log("parent_login_details:", this.parent_login_details)
          console.log("emp_login_details:", this.emp_login_details)
          if (this.parent_login_details.length === 0 && this.emp_login_details.length === 0) {
            this.showSnackbar("warning", "No data available for the selected criteria")
          }
        }
      } catch (err) {
        console.log("logins error:", err)
        this.onerror(err)
        this.parent_login_details = []
        this.emp_login_details = []
        this.login_usernames_from_logs = []
        this.login_count = '' 
      } finally {
        this.log_loader = false
      }
    },
    fnExcelReport(id, name) {
      this.export_loader = true;
      let tab_text = `<table border='1px'>
        <tr>
          <th>Sr. No.</th>
          <th>Name</th>
          <th>PRN</th>
          <th>Username</th>
        </tr>`;

      this.tableItems.forEach((item, index) => {
        tab_text += `
          <tr>
            <td>${index + 1}</td>
            <td>${item.name || ''}</td>
            <td>${item.prn || ''}</td>
            <td>${item.email || ''}</td>
          </tr>`;
      });

      tab_text += '</table>';

      const blob = new Blob([tab_text], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
      this.export_loader = false;
    },
    fnExcelReportEmployee(id, name) {
      this.export_loader = true
      let tab_text = `<table border='1px'>
        <tr>
          <th>Sr. No.</th>
          <th>Name</th>
          <th>Code</th>
          <th>Login Id</th>
          <th>Contact</th>
        </tr>`
      this.emp_login_details.forEach((s, index) => {
        tab_text += `
          <tr>
            <td>${index + 1}</td>
            <td>${s.emp_name || ''}</td>
            <td>${s.emp_code || ''}</td>
            <td>${s.emp_login || ''}</td>
            <td>${s.emp_contact || ''}</td>
          </tr>`
      })
      tab_text += '</table>'
      const blob = new Blob([tab_text], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      })
      const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls'

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, filename)
      } else {
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = filename
        a.click()
        window.URL.revokeObjectURL(url)
      }
      this.export_loader = false
    },
  },
}
</script>

<style scoped>
div[style*="max-height"] {
  width: 100%;
  padding: 10px;
  margin-left: 10px;
}

.v-data-table {
  background-color: #fff;
  border-radius: 4px;
}

.v-data-table th {
  font-weight: bold;
  background-color: #f5f5f5;
}

.v-data-table td {
  padding: 8px;
}

.v-data-table__footer {
  padding: 10px;
  font-size: 14px;
}
</style>